/**
* All site tour related
*
* Created by Paul on 25/9/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

// Joyride imports
import Joyride from "react-joyride"
import { ACTIONS, EVENTS } from 'react-joyride/es/constants'

import './style.scss'

import {ActionCreator} from "../../actions";

class Tour extends Component {

    static propTypes = {
        joyride: PropTypes.shape({
            callback: PropTypes.func
        })
    };

    static defaultProps = {
        joyride: {}
    };

    state = {
        continuous: true,
        loading: false,
        run: false,
        spotlightPadding: 0,
        styles: {
            options: {
                primaryColor: "#31259F",
                textColor: "#000",
                overlayColor: "rgba(0, 0, 0, 0.65)",
            },
            buttonSkip: {
                fontSize: 12,
                paddingLeft: 0,
            },
            buttonClose: {
                display: 'none',
            },
            tooltip: {
                padding: 25,
                borderRadius: 0,
            },
            tooltipTitle: {
                margin: '0',
            },
            tooltipContent: {
                padding: '10px 0px',
                fontSize: 12,
                textAlign: 'left'
            },
            tooltipFooter: {
                marginTop: 10
            },
            buttonNext: {
                padding: '8px 16px',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: '21px',
            },
            buttonBack: {
                fontSize: 12,
            }
        },
        steps: [{
            title: <div className="tour__main-title">Welcome to Selfmade!</div>,
            content:   <div>
                            <div className="tour__main-desc">Congratulations, you have completed the account establishment
                                process for your new SMSF. There are a few more important steps you need to complete
                                before your account is fully activated and you are able to start investing.</div>
                            <p className="tour__main-point"><span className="tour__main-point__highlight">Sign establishment documents</span> - You and any
                                other trustees/members need to sign the establishment documents via Docusign</p>
                            <p className="tour__main-point"><span className="tour__main-point__highlight">Activate bank accounts</span> - your SMSF’s new
                                Cash Management and Online Trading Accounts have been set up with Macquarie but need to be activated before you can
                                start investing</p>
                            <p className="tour__main-point"><span className="tour__main-point__highlight">Set up contributions</span> - Set up future
                                employer contributions to be paid into your new SMSF</p>
                            <p className="tour__main-point"><span className="tour__main-point__highlight">Roll over</span> – Roll your existing super into
                                your new SMSF</p>

                        </div>,
            placement: "center",
            disableBeacon: true,
            styles: {
                options: {
                    width: 750,
                    zIndex: 10000
                }
            },
            locale: { skip: "Skip", next: "Take a Quick Tour" },
            target: "body"
        },
        {
            title: <div className="tour__main-title">Pending Actions</div>,
            content: <div>This is where we will keep you updated with any actions required by you to keep your SMSF up
                            to date and compliant.</div>,
            placement: "left",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500
                }
            },
            target: ".right-menu__middle-container",
            spotlightPadding: 3,
        },
        {
            title: <div className="tour__main-title">Notifications Panel</div>,
            content: <div>You can minimise the notifications panel here. If you have any outstanding
                actions that need your attention, the panel will be open when you next log in.</div>,
            placement: "left",
            disableBeacon: true,
            styles: {
                options: {
                    width: 515
                }
            },
            target: ".right-menu-container__close-container",
            spotlightPadding: 3,
        },
        {
            title: <div className="tour__main-title">Dashboard</div>,
            content: <div>The dashboard gives you a snapshot of your SMSF including your fund's investment holdings, the
                fund value, a list of recent transactions as well as a feed of interesting news articles relevant to
                SMSF Trustees and Members. You'll probably spend most of your time here.</div>,
            placement: "right",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500
                }
            },
            target: ".dashboard_target",
        },
        {
            title: <div className="tour__main-title">My Fund</div>,
            content: <div>This section displays all the important details of your SMSF including details of trustees and
                members, registered addresses, the fund name and any other registration details.</div>,
            placement: "right",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500
                }
            },
            target: ".myfund_target",
        },
        {
            title: <div className="tour__main-title">Trading</div>,
            content: <div>This button will send you to the Macquarie login page to access your SMSF’s new transaction
                and online trading accounts. You will have received separate emails from Macquarie with login details
                for the Macquarie site. It is important that you complete the Macquarie activation steps ASAP so that
                you are able to roll over your existing super and receive new contributions.</div>,
            placement: "right",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500
                }
            },
            target: ".trading_target",
        },
        {
            title: <div className="tour__main-title">Documents</div>,
            content: <div>You can access your SMSF’s documents here at any time. Any new documents that require signing,
                like your fund's tax returns and annual compliance reports, will be posted here for signing.</div>,
            placement: "right",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500
                }
            },
            target: ".documents_target",
        },
        {
            title: <div className="tour__main-title">Billing</div>,
            content: <div>You can review your fund's invoices here at any time.</div>,
            placement: "right",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500
                }
            },
            target: ".billing_target",
        },
        {
            title: <div className="tour__main-title">Let's get started</div>,
            content: <div>You’re all set, now it's time to complete the activation steps and take control of your
                super.</div>,
            placement: "center",
            disableBeacon: true,
            styles: {
                options: {
                    width: 500,
                    zIndex: 10000
                }
            },
            locale: { back: "", skip: "Skip", last: "Go to the Documents page" },
            target: "body"
        }],
        stepIndex: 0
    };

    handleJoyrideCallback = data => {

        const { action, index, type } = data;
        const { setOpenRightMenu, setOnTour, goToRoute, setOnTourHighlight } = this.props

        //console.log('action: ' + action);
        //console.log('index: ' + index);
        //console.log('type: ' + type);

        if (type === EVENTS.TOUR_START && this.state.run) {
            setOnTour(true)
        }
        else if (type === EVENTS.TOUR_END && this.state.run) {

            // End the tour
            this.setState({
                run: false
            });

            setOnTour(false)
        }
        else if (type === EVENTS.STEP_AFTER && action === ACTIONS.NEXT && index === 2) {

            this.setState({ run: false, loading: true });

            setOpenRightMenu(false);

            setTimeout(() => {
                this.setState({
                    loading: false,
                    run: true,
                    stepIndex: index + (action === ACTIONS.PREV ? -1 : 1)
                });
            }, 850);
        }
        else if (type === EVENTS.STEP_AFTER && action === ACTIONS.PREV && index === 3) {

            this.setState({ run: false, loading: true });

            setOpenRightMenu(true);

            setTimeout(() => {
                this.setState({
                    loading: false,
                    run: true,
                    stepIndex: index + (action === ACTIONS.PREV ? -1 : 1)
                });
            }, 850);
        }
        else if (type === EVENTS.STEP_AFTER && index === 8) {

            // End the tour
            this.setState({
                run: false
            });

            setOnTour(false)
            setOpenRightMenu(false);
            goToRoute('/documents')
        }
        else if (type === EVENTS.STEP_AFTER) {
            this.setState({
                stepIndex: index + (action === ACTIONS.PREV ? -1 : 1)
            });
        }
        else if (type === EVENTS.TOOLTIP_CLOSE) {
            this.setState({ stepIndex: index + 1 });
        }

        if (index === 3) {
            setOnTourHighlight('DASHBOARD')
        }
        else if (index === 4) {
            setOnTourHighlight('MY FUND')
        }
        else if (index === 5) {
            setOnTourHighlight('TRADING')
        }
        else if (index === 6) {
            setOnTourHighlight('DOCUMENTS')
        }
        else if (index === 7) {
            setOnTourHighlight('BILLING')
        }
        else {
            setOnTourHighlight('')
        }
    };

    componentWillMount() {
        const { breakPointObj, location, getProfileData } = this.props

        getProfileData()

        if (location.pathname === '/' && location.search === "?runTour"
            && breakPointObj.greaterThan.medium) {

            this.setState({
                run: true
            });
        }
    }

    componentDidMount() {

    }

    componentWillUpdate(nextProps, nextState) {

        const { breakPointObj, profile, location } = this.props

        // Watch for profile data, and if user is new to the site, flag the tour to start
        if((profile['is_new'] !== nextProps.profile['is_new'])
            && nextProps.profile['is_new'] === true && location.pathname === '/'
            && breakPointObj.greaterThan.medium) {

            // Only want to display the tour once
            let updatedProfile = nextProps.profile
            updatedProfile['is_new'] = false

            // Push the change
            this.props.updateProfileRequest(updatedProfile)

            // Run the tour
            this.setState({
                run: true
            });
        }
    }

    render() {

        const { ...joyrideProps } = this.state;
        const props = {
          ...joyrideProps,
          ...this.props.joyride
        };

        return (

            <Joyride
              scrollToFirstStep
              showSkipButton
              {...props}
              callback={this.handleJoyrideCallback}
            />
        )
    }
}

// define the prop types
Tour.propTypes = {
    breakPointObj: PropTypes.object,
    getProfileData: PropTypes.func.isRequired,
    profile: PropTypes.object,
    goToRoute: PropTypes.func.isRequired,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        breakPointObj: state.browser,
        openRightMenu: state.componentState.openRightMenu,
        onTour: state.componentState.onTour,
        onTourHighlight: state.componentState.onTourHighlight,
        profile: state.profileState.data,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setOpenRightMenu: action.setOpenRightMenu,
        getProfileData: action.getProfileData,
        setOnTour: action.setOnTour,
        setOnTourHighlight: action.setOnTourHighlight,
        updateProfileRequest: action.updateProfileRequest,
        goToRoute: action.goToRoute
    }
}
/*
    you can get access to the history object's properties and the closest
    <Route>'s match via the `withRouter` higher-order component. `withRouter`
    will pass updated match, location, and history props to the wrapped
    component whenever it renders.
*/
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Tour))


// WEBPACK FOOTER //
// ./src/components/Tour/index.js